import Link from 'next/link';

// Ported from app/not-found.tsx.
export default function NotFoundPage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-slate-950 text-white px-4">
      <div className="text-center max-w-md">
        <h1 className="text-7xl font-black text-[#FF8A00] mb-4">404</h1>
        <h2 className="text-2xl font-bold mb-2">Page not found</h2>
        <p className="text-slate-400 mb-8 text-sm">
          This address is not part of the site. It may have moved, or the link may be wrong.
        </p>
        <Link
          href="/"
          className="inline-flex items-center justify-center px-6 py-3 bg-[#FF8A00] hover:bg-[#ea7900] text-white font-bold text-xs uppercase tracking-wider rounded-xl transition-all"
        >
          Go home
        </Link>
      </div>
    </div>
  );
}
